/**
 * Created by laugh on 12/6/2017.
 */
import React, { Component } from 'react';
import $ from 'jquery';
import {
    BrowserRouter as Router,
    Route,
    Redirect,
    Link
} from 'react-router-dom'
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as ReactBootstrap from 'react-bootstrap';
import 'font-awesome/css/font-awesome.css';
import './core.css';
class MainFooter extends React.Component {
    constructor(props) {
        super(props);
        console.log(props.testing);
        this.state = {test: "testing"};
    }

    componentWillMount() {
        // if(this.state.provider != "") {
        //     require('../assets/css/' + this.state.provider + '.css');
        // }

    }
    //TODO set referrer url link in containers first child link
    render() {
        return (
            <div>
                <footer id="footer">
                    <div className="container-fluid">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-offset-1 col-sm-4">
                                    <span>connect with us</span> <br></br>
                                    <i className="fa fa-facebook-square fa-2x"> </i>
                                    <i className="fa fa-twitter-square fa-2x"> </i>
                                    <i className="fa fa-git-square fa-2x"> </i>
                                    <i className="fa fa-google-plus-square fa-2x"> </i>
                                </div>
                                <div className="col-sm-7 text-right">
                                    contact us <br></br>
                                    918-928-9644 <br></br>
                                    webmaster@mealtrist.com
                                </div>
                            </div>
                        </div>
                    </div>

                        {/*<div className="row">*/}
                            {/*<div className="col-sm-8"><a href="#" title={this.state.provider}><img className="img-responsive" height="60" width="60" src={logo} alt="mealtrist-logo" /></a></div>*/}
                            {/*<div className="col-sm-2">Login/Register</div>*/}
                            {/*<div className="col-sm-2">Contact</div>*/}
                        {/*</div>*/}

                </footer>
            </div>
        );
    }
}

export default MainFooter;


// WEBPACK FOOTER //
// ./src/components/Core/footer.js